import { t } from "../../../utils/i18n";
import React, { useCallback } from "react";
import Toggle from "react-toggle";
import Modal from "react-modal";
import { Oval } from "react-loader-spinner";
import card from "../images/Gold-Elegant-Business-Card.png";
import "react-toggle/style.css";
import "../styles/card.scss";
import { postRequest } from "../../../utils/httpRequest";
import toastr from "toastr";

function DebitCard({ card: cardDetail, cardBalance: initialCardBalance }) {
  toastr.options.positionClass = "toast-top-center";
  toastr.options.showDuration = "10000";
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const [cardNumber, setCardNumber] = useState("");
  const [activateModalIsOpen, setActivateModalIsOpen] = useState(false);
  const [cardDetailsModalIsOpen, setCardDetailsModalIsOpen] = useState(false);
  const [isActivatingCard, setIsActivatingCard] = useState(false);
  const [fetchedCardBalance, setFetchedCardBalance] = useState(null);
  console.log(cardNumber);

  useEffect(() => {
    if (cardDetail && cardDetail.id) {
      getRequest(`/api/v1/cards/${cardDetail.id}`)
        .then((response) => {
          if (response && typeof response.balance !== "undefined") {
            setFetchedCardBalance(response.balance);
          }
        })
        .catch((error) => {
          console.error("Error fetching card details for balance:", error);
          // Optionally set to a default or error state
        });
    }
  }, [cardDetail]);

  const submitCardActivation = useCallback(
    (e) => {
      setIsActivatingCard(true);
      postRequest("/api/v1/cards/activations", {
        card_number: cardNumber,
      })
        .then((response) => {
          setActivateModalIsOpen(false);
          toastr.success(t("cards.debit_card.activation_submitted"));
        })
        .catch((error) => {
          toastr.error(
            error?.data?.[0]?.detail ||
              error?.data?.error ||
              error?.data?.message ||
              t("cards.common.something_went_wrong")
          );
        });
      setIsActivatingCard(false);
    },
    [setIsActivatingCard, cardNumber, toastr]
  );

  return (
    <div className="dbt-ctn">
      <div className="overlay">
        <p className="card-number">XXXX XXXX XXXX XXXX</p>
        <p className="expires-in">{cardDetail.status}</p>
        <p className="card-holder-name">{`${cardDetail.first_name} ${cardDetail.last_name}`}</p>
        <p className="card-balance-display">
          {t("cards.debit_card.balance")}{" "}
          {(fetchedCardBalance ? fetchedCardBalance : initialCardBalance)
            ? (fetchedCardBalance
                ? fetchedCardBalance
                : initialCardBalance
              ).toLocaleString(undefined, {
                style: "currency",
                currency: "USD",
              })
            : "$0.00"}
        </p>
      </div>
      <img src={card} alt="" />
      <div className="card-actions">
        <div className="card-activation">
          {activateModalIsOpen == false && (
            <div className="activate-deactivate-card">
              <Toggle
                id={`card-status-toggle-${cardDetail.id}`}
                defaultChecked={cardDetail.status === "active"}
                disabled={["processed", "active", "completed"].includes(
                  cardDetail.status
                )}
                onChange={(e) => {
                  setActivateModalIsOpen(true);
                }}
              />
              <label htmlFor={`card-status-toggle-${cardDetail.id}`}>
                {cardDetail.status == "active" ? t("cards.debit_card.active") : t("cards.debit_card.activate")}
              </label>
            </div>
          )}
          {activateModalIsOpen == true && (
            <div className="oval-loader-container">
              <Oval
                visible={true}
                height="30"
                width="30"
                color="#4fa94d"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
                strokeWidth={5}
              />
            </div>
          )}
        </div>
        <div className="card-activation">
          {cardDetailsModalIsOpen == false && (
            <button
              type="button"
              className="btn btn-outline-primary mb-3"
              onClick={(e) => {
                setCardDetailsModalIsOpen(true);
              }}
            >
              {t("cards.debit_card.view_card_details")}
            </button>
          )}
          {cardDetailsModalIsOpen == true && (
            <div className="oval-loader-container">
              <Oval
                visible={true}
                height="30"
                width="30"
                color="#4fa94d"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
                strokeWidth={5}
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        isOpen={cardDetailsModalIsOpen}
        style={customStyles}
        contentLabel="card-status-modal"
        shouldCloseOnOverlayClick={false}
        size="max-w-lg"
      >
        <h4>{t("cards.debit_card.card_details")}</h4>
        <div className="row">
          <div className="col-md-4">
            <div
              className="card"
              style={{ width: "18rem", backgroundColor: "rgba(0,0,0,.07)" }}
            >
              <div className="card-header">{t("cards.debit_card.personal_details")}</div>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">
                  {t("cards.debit_card.first_name")} {cardDetail?.first_name}
                </li>
                <li className="list-group-item">
                  {t("cards.debit_card.last_name")} {cardDetail?.last_name}
                </li>
                <li class="list-group-item">{t("cards.debit_card.title")} {cardDetail?.title}</li>
                <li class="list-group-item">
                  {t("cards.debit_card.phone_number")} {cardDetail?.phone_number}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-4">
            <div
              className="card"
              style={{ width: "18rem", backgroundColor: "rgba(0,0,0,.07)" }}
            >
              <div className="card-header">{t("cards.debit_card.means_of_identification")}</div>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">
                  {t("cards.debit_card.passport_number")} {cardDetail?.passport_number}
                </li>
                <li className="list-group-item">
                  {t("cards.debit_card.issuance_date")} {cardDetail?.passport_issued_date}
                </li>
                <li className="list-group-item">
                  {t("cards.debit_card.id_type")} {cardDetail?.id_type}
                </li>
                <li className="list-group-item">
                  {t("cards.debit_card.expiry_date")} {cardDetail?.passport_expiry_date}
                </li>
                <li className="list-group-item">
                  {t("cards.debit_card.issuance_country")} {cardDetail?.passport_issued_by}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-4">
            <div
              className="card"
              style={{ width: "18rem", backgroundColor: "rgba(0,0,0,.07)" }}
            >
              <div className="card-header">{t("cards.debit_card.card_mailing_address")}</div>
              <ul className="list-group list-group-flush">
                <li className="list-group-item">
                  {t("cards.debit_card.card_network")} {cardDetail?.card_network}
                </li>
                <li className="list-group-item">
                  {t("cards.debit_card.card_type")} {cardDetail?.card_type}
                </li>
                <li className="list-group-item">
                  {t("cards.debit_card.country")} {cardDetail?.country}
                </li>
                <li className="list-group-item">{t("cards.debit_card.state")} {cardDetail?.state}</li>
                <li className="list-group-item">
                  {t("cards.debit_card.postal_code")} {cardDetail?.postal_code}
                </li>
                <li className="list-group-item">
                  {t("cards.debit_card.address")} {cardDetail?.address}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="btn btn-danger mb-3"
          onClick={(e) => setCardDetailsModalIsOpen(false)}
        >
          {t("cards.common.close")}
        </button>
      </Modal>
      <Modal
        isOpen={activateModalIsOpen}
        style={customStyles}
        contentLabel="card-status-modal"
        shouldCloseOnOverlayClick={false}
        size="max-w-lg"
      >
        <h4>{t("cards.debit_card.activate_card")}</h4>
        <div className="mb-20" style={{ marginBottom: "20px" }}>
          <label htmlFor="card-number">{t("cards.debit_card.provide_card_number")}</label>
          <input
            id="card-number"
            className="form-control"
            type="text"
            placeholder="XXXX XXXX XXXX XXXX"
            aria-label={t("cards.debit_card.search")}
            value={cardNumber}
            onChange={(e) => {
              setCardNumber(e.target.value);
            }}
            style={{ width: "350px" }}
          />
        </div>
        <button
          type="button"
          className="btn btn-danger mb-3"
          onClick={(e) => setActivateModalIsOpen(false)}
          disabled={isActivatingCard}
        >
          {t("cards.common.close")}
        </button>
        &nbsp;&nbsp;&nbsp;
        <button
          type="button"
          className="btn btn-primary mb-3"
          disabled={isActivatingCard}
          onClick={submitCardActivation}
        >
          {cardDetail.status === "active" ? t("cards.debit_card.deactivate") : t("cards.debit_card.activate")}
        </button>
        <br />
      </Modal>
    </div>
  );
}

export default DebitCard;
